import type { GridFilterInputValueProps } from '@mui/x-data-grid-pro'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'

import { useEnumTranslation } from '@cbgms/base/enums/use-enum-translation'

import { useDataGridConfig } from './DataGridConfigProvider'

interface DataGridFilterSingleSelectProps extends GridFilterInputValueProps {
  clearButton: React.ReactNode
  inputRef: React.Ref<HTMLInputElement>
  label: string
  tabIndex: number
}

export function DataGridFilterSingleSelect({
  apiRef,
  applyValue,
  clearButton,
  inputRef,
  item,
  label,
  tabIndex
}: DataGridFilterSingleSelectProps) {
  const { te } = useEnumTranslation()
  const { queryValueOptions } = useDataGridConfig()

  const handleChange = (event: SelectChangeEvent) => {
    applyValue({
      ...item,
      value: event.target.value
    })
  }

  const colDef = apiRef.current.getColumn(item.field)

  // according to MUI's type it can be either string or undefined
  // in reality it's always defined that's why we're using
  // the non null assertion operator (!) here
  const type = colDef.type!
  const options = queryValueOptions(type)

  const id = `${colDef.field}-id`
  const labelId = `${colDef.field}-labelId`

  return (
    <>
      <FormControl fullWidth variant='standard'>
        <InputLabel id={labelId} htmlFor={id} variant='standard'>
          {label}
        </InputLabel>
        <Select
          ref={inputRef /* inputRef passes by mui, It must be set on actual DOM element or the underlying mui code will error */}
          id={id}
          inputProps={{ tabIndex }}
          fullWidth
          labelId={labelId}
          onChange={handleChange}
          value={item.value ?? ''}
          variant='standard'
        >
          {options.map(option => (
            <MenuItem key={option} value={option}>
              {te(type, option)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {clearButton ? (
        // inline-flex is required so it lines out towards the bottom
        // auto 0 10px 5px is the default margins of the buttons
        // in the header filter e.g. clear and filter menu
        <Box display='inline-flex' margin='auto 0 10px 5px'>
          {clearButton}
        </Box>
      ) : null}
    </>
  )
}
